<template>
	<div class="full" style="background-color: white;">
		<el-form ref="baseinfoform" :model="form" label-width="80px" v-loading="loading" style="flex: 1;position: relative;"
			element-loading-background="rgba(255, 255, 255, 0.5)">
			<el-form-item label="万里牛ID" label-width="80px" style="width: 600px;">
				<el-input readonly size="mini" v-model="form.wlnid">
					<el-button slot="append" icon="el-icon-search" @click="getwlnid"></el-button>
				</el-input>
				<el-input readonly size="mini" v-model="form.wlnname"></el-input>
			</el-form-item>
		</el-form>
	</div>

</template>
<style scoped>
	.bread {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	export default {
		props: {
			emunid: {
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				loading:false,
				form: {
					wlnid: null,
					wlnname:null
				}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			getwlnid() {
				this.loading = true
				this.$api.emunextend_paymentaccount.getwlnid({
					emunvalueid: this.emunid
				}).then((res) => {
					this.form.wlnid = res.acc_uid
					this.form.wlnname = res.acc_name
					this.loading = false
				},()=>{
					this.loading = false
				})
			}
		},
		components: {

		}
	}
</script>